import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: routes,
  
  // 参考：https://router.vuejs.org/guide/advanced/scroll-behavior.html#async-scrolling
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

// 解决微信在路由切换时，地址不改变问题
routes.forEach((route) => {
  route.beforeEnter = (to, from, next) => {
    if (from.path !== '/') {
        router.go(to.path)
      }
      next()
  }
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js